import React, { useRef } from 'react';
import { Box, Button, ButtonBase, IconButton, Tooltip, Typography } from '@mui/material';
import {
  ArrowDropDown as ArrowDropDownIcon,
  CalendarMonth as CalendarIcon,
  ChevronLeft as ChevronLeftIcon,
  ChevronRight as ChevronRightIcon,
} from '@mui/icons-material';
import { formatDateYYYYMMDD, parseLocalDate } from '../../utils/dateHelpers';

const addDays = (d, n) => new Date(d.getFullYear(), d.getMonth(), d.getDate() + n);

/** Selettore del giorno: frecce, data cliccabile (apre il calendario del browser) e "Today". */
export default function DayNavigator({ date, onChange }) {
  const pickerRef = useRef(null);
  const key = formatDateYYYYMMDD(date);
  const isToday = key === formatDateYYYYMMDD(new Date());

  const openPicker = () => {
    const el = pickerRef.current;
    if (!el) return;
    if (typeof el.showPicker === 'function') el.showPicker();
    else el.focus();
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
      <Tooltip title="Previous day">
        <IconButton size="small" onClick={() => onChange(addDays(date, -1))}>
          <ChevronLeftIcon />
        </IconButton>
      </Tooltip>
      <ButtonBase
        onClick={openPicker}
        sx={{
          position: 'relative',
          gap: 1,
          px: 1.5,
          height: 40,
          borderRadius: 1,
          border: '1px solid',
          borderColor: 'divider',
          '&:hover': { bgcolor: 'var(--rt-grey-50)', borderColor: 'text.secondary' },
        }}
      >
        <CalendarIcon fontSize="small" sx={{ color: 'text.secondary' }} />
        <Typography sx={{ fontWeight: 700, minWidth: 190, textAlign: 'left' }}>
          {date.toLocaleDateString('en-GB', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })}
        </Typography>
        <ArrowDropDownIcon sx={{ color: 'text.secondary', ml: -0.5 }} />
        <input
          ref={pickerRef}
          type="date"
          tabIndex={-1}
          aria-label="Pick a date"
          value={key}
          onChange={(e) => e.target.value && onChange(parseLocalDate(e.target.value))}
          style={{ position: 'absolute', inset: 0, opacity: 0, pointerEvents: 'none' }}
        />
      </ButtonBase>
      <Tooltip title="Next day">
        <IconButton size="small" onClick={() => onChange(addDays(date, 1))}>
          <ChevronRightIcon />
        </IconButton>
      </Tooltip>
      {!isToday && (
        <Button
          size="small"
          variant="outlined"
          color="inherit"
          onClick={() => onChange(new Date())}
          sx={{ textTransform: 'none', ml: 0.5, borderColor: 'divider' }}
        >
          Today
        </Button>
      )}
    </Box>
  );
}
